import React from 'react';
import {Navigate, Outlet} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

const ClientAdminLayout = () => {

    //TODO check auth permissions
    const {auth, isLoaded} = useAuth();
    if (isLoaded && (!auth || !auth.canManageClients())) {
        return <Navigate to={TB.auth().appropriate()} replace />;
    }
    if(!isLoaded || !auth) {
        return null;
    }

    return (
        <Outlet/>
    );
};

export default ClientAdminLayout;